import { Typography } from "@mui/material";
import { useMemo } from "react";

import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import MenuDropDownButton from "../../../../../ui library/components/buttons/MenuDropDownButton";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import { STYLES } from "../../utils/customStyles";
import CustomTextField from "../fields/CustomTextField";

import ModalField from "./ModalField";

export default function AdditionalContactEditView({
  fieldName,
  typesMap,
  order,
  orderKey,
  dataMap,
  addButtonLabel,
  emptyText,
  fieldSuffixLabel,
  valueKey,
  placeholder,
  onChange,
  onDelete,
}) {
  const menuListItems = useMemo(() => {
    if (!typesMap) {
      return [];
    }

    const selectedSet = new Set(order);
    return [...typesMap.entries()]
      .filter(([type]) => !selectedSet.has(type))
      .map(([type, item]) => ({
        index: type,
        name: item.label,
        onClick: () => {
          onChange(`${fieldName}.${type}.${valueKey}`, "");
          onChange(orderKey, [...order, type]);
        },
      }));
  }, [typesMap, order, fieldName, orderKey, valueKey, onChange]);

  const disabled = menuListItems.length === 0;

  return (
    <div className="flex w-full flex-row items-stretch gap-4">
      <div className={`center h-full ${order.length > 0 ? "mt-6" : ""}`}>
        <MenuDropDownButton
          menuList={{ menuListItems }}
          sx={{
            ...STYLES.menuDropdownButtonStyle,
            "&.MuiButtonBase-root": { padding: "3px" },
            backgroundColor: disabled ? HNSColors.neutrals[800] : HNSColors.neutrals[50],
            border: disabled ? "none" : `1px solid ${HNSColors.secondary[500]}`,
          }}
          className="group w-fit rounded-[500px] px-2 font-normal normal-case"
          disabled={disabled}
        >
          <div className="flex flex-row items-center gap-2 p-1">
            <Typography
              className="text-[12px] font-normal group-hover:font-semibold"
              style={{ color: disabled ? HNSColors.neutrals[500] : HNSColors.secondary[500] }}
            >
              {addButtonLabel}
            </Typography>
            <Svg
              name={SvgEnum.HisPlusCircle}
              color={disabled ? HNSColors.neutrals[500] : HNSColors.secondary[500]}
              sx={{ height: 24, width: 24 }}
            />
          </div>
        </MenuDropDownButton>
      </div>

      <div className="flex flex-1 flex-col justify-center gap-2">
        {order.length === 0 ? (
          <Typography
            sx={{ color: HNSColors.neutrals[500] }}
            className="w-full px-10 text-[14px] italic"
          >
            {emptyText}
          </Typography>
        ) : (
          <div className="flex flex-col gap-2 px-4">
            {order.map((type) => {
              const itemObj = dataMap[type];
              const label = typesMap.get(Number(type))?.label;

              return (
                <div key={type} className="flex w-full items-end gap-2">
                  <ModalField
                    label={`${label} ${fieldSuffixLabel}`}
                    renderValue={
                      <CustomTextField
                        placeholder={placeholder}
                        fieldName={type}
                        fieldValue={itemObj?.[valueKey] || ""}
                        onChange={(t, v) => onChange(`${fieldName}.${t}.${valueKey}`, v)}
                      />
                    }
                  />
                  <CustomIconButton
                    iconVisible
                    CustomIcon={
                      <Svg
                        name={SvgEnum.HisTrash2}
                        color={HNSColors.failure[500]}
                        onClick={() => onDelete(`${fieldName}.${type}`, type)}
                        sx={{ height: 24, width: 24 }}
                      />
                    }
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
